import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FormButton } from 'src/app/components/form-button/form-button.component';

@Component({
  selector: 'app-reset-password',
  standalone: false,
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  passwordButton: FormButton = new FormButton('Reset Password', '');

  passwordsInvalid: boolean = true;

  passwordForm: FormGroup;

  constructor(private router: Router, private formBuilder: FormBuilder ) {
    this.passwordForm = this.formBuilder.group({
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });
  }

  ngOnInit() {
  }

  validatePasswords() {
    if (this.passwordForm.value['newPassword'] != this.passwordForm.value['confirmPassword']) {
      this.passwordsInvalid = true;
    } else {
      this.passwordsInvalid = false;
    }
  }

  resetPassword() {
    console.log(this.passwordForm.value);
    // do the reset password thing
  }

}
